import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c30b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tr" }
const _hoisted_2 = { class: "td rowhead" }
const _hoisted_3 = { class: "td choice" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "td choice" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "gerechtvaardigdBelang"
}

import { computed } from "vue";
import VueCheckbox from "../components/Checkbox.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'NietBenaderen',
  props: {
  label: {
    type: String,
    default: "",
  },
  nietBenaderen: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (e: "click", newVal: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const i18n = useI18n();
const { t } = i18n;
 




const nietBenaderenComp = computed<boolean>(() => {
  return props.nietBenaderen || false;
});

function toggle(): void {
  emit("click", !nietBenaderenComp.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["permission-table", { header: true }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(VueCheckbox, {
          modelValue: _unref(nietBenaderenComp),
          onInput: toggle
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_4,
      _hoisted_5
    ]),
    (_unref(nietBenaderenComp))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)("gerechtvaardigdBelangVerklaring")), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})